import { render, staticRenderFns } from "./AgencyShopping.vue?vue&type=template&id=46ed02a9&scoped=true"
import script from "./AgencyShopping.vue?vue&type=script&lang=js"
export * from "./AgencyShopping.vue?vue&type=script&lang=js"
import style0 from "./AgencyShopping.vue?vue&type=style&index=0&id=46ed02a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ed02a9",
  null
  
)

export default component.exports